

<kendo-grid class="isg-grid"
            [data]="gridService | async"
            [loading]="gridService.loading"
            [pageSize]="state.take"
            [skip]="state.skip"
            [sort]="state.sort"
            [navigable]="true"
            [pageable]="{
                  pageSizes:[5, 10, 15, 20, 50]
            }"
            (dataStateChange)="onStateChange($event)"
            [height]="heightGrid">

  <kendo-grid-column field="assigned" title="Assigned" editor="boolean" [width]="90" class="isg-kgrid-cell-center">
      <ng-template kendoGridCellTemplate let-dataItem>
        <kendo-switch [checked]="dataItem.assigned"
                      (valueChange)="onAssignedChange(dataItem, $event)">
        </kendo-switch>
      </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="active" title="Is Active" editor="boolean" [width]="90" class="isg-kgrid-cell-center">
    <ng-template kendoGridCellTemplate let-dataItem>
      <kendo-switch [checked]="dataItem.active"
                    (valueChange)="onActiveChange(dataItem, $event)">
      </kendo-switch>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="firstName" title="First Name"> </kendo-grid-column>
  <kendo-grid-column field="lastName" title="Last Name"> </kendo-grid-column>

  <kendo-grid-column field="lastLogin" title="Last Login" editor="date" [width]="150">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{dataItem.lastLogin | datePreference:true}}
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="accessSent" title="Access Sent On" editor="date" [width]="150">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{dataItem.accessSent | datePreference:true}}
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column title="Send Access Email" editor="boolean" field="checked" [width]="150" class="isg-kgrid-cell-center">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span *ngIf="dataItem.assigned === true && (dataItem.lastLogin === null || dataItem.lastLogin === undefined)" [(appNullableBooleanClass)]="dataItem.checked" [allowClickToggle]="true" [allowTrueFalseToggle]="true"></span>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="email" title="Email"> </kendo-grid-column>

  <kendo-grid-messages [pagerItemsPerPage]="'Users per request'" [pagerItems]="'Users'"
                       [pagerOf]="'of'" [pagerPage]="'Page'">
  </kendo-grid-messages>

</kendo-grid>

